import { FC } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";

type Props = {
    /** Quantas consultas estão marcadas. Com zero, a barra não aparece. */
    count: number;
    /** true enquanto a receita está sendo gerada: trava os dois botões. */
    loading?: boolean;
    onClear: () => void;
    onGenerate: () => void;
};

/** Rodapé do card do paciente: contagem da seleção e ação de gerar a receita. */
const SelectionBar: FC<Props> = ({ count, loading, onClear, onGenerate }) => {
    const theme = useTheme();

    if (count === 0) return null;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1.25,
                borderTop: `1px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.brand.surface2,
            }}
        >
            <Typography aria-live="polite" sx={{ flex: 1, minWidth: 0, fontSize: "13px", color: "text.secondary" }}>
                {count} {count === 1 ? "selecionada" : "selecionadas"}
            </Typography>

            <Button size="small" onClick={onClear} disabled={loading} sx={{ fontSize: "12.5px", color: "text.secondary" }}>
                Limpar
            </Button>

            <Button size="small" variant="contained" onClick={onGenerate} disabled={loading} sx={{ fontSize: "12.5px" }}>
                {loading ? "Gerando…" : "Gerar receita"}
            </Button>
        </Box>
    );
};

export default SelectionBar;
